/* eslint-disable no-unused-vars, no-undef */
MLCV.Print = {
    AttachEventHandlers: function () {
        const originalUrl = jQuery('.social-media-link-ls ul li.printing a').attr('href');

        function updatePrintLink() {
            const $activeTab = jQuery('.tabs-module .tabs-module-holder .nav-tabs .nav.active a');

            if ($activeTab.length > 0) {
                const activeTabUrl = $activeTab.attr('href');
                const paneCount = $activeTab.attr('data-pane-count');
                const initprintUrl = originalUrl;

                jQuery('.social-media-link-ls ul li.printing a').attr('href', initprintUrl + '&t=' + paneCount + activeTabUrl);
            }
        }

        updatePrintLink();

        jQuery("a[data-toggle='tab']").on('shown.bs.tab', function (e) {
            updatePrintLink()
        });

        jQuery(".pdf-link").click(function () {
            const pdfLink = jQuery(this).data('pdf-url');
            if (pdfLink.length < 1) {
                return false;
            }

            window.location = pdfLink + "&browswetitle=" + encodeURIComponent(document.title);
            return false;
        });

        //if (jQuery(window).width() <= 641) {
        //    var $tabModuleHeight = jQuery('.tabs-module').height();
        //    if ($tabModuleHeight == null || $tabModuleHeight == 0) {
        //        jQuery('.social-share').css({ 'padding-top': '25px', 'padding-bottom': '40px' });
        //    }
        //}
        if(!jQuery(".subnavigation-module-header-menu").length){
            $("#top-header").css("border-bottom", "2px solid #000");
        }
    }
}

jQuery(document).ready(function () {
    MLCV.Print.AttachEventHandlers();

});